import React, { Children } from 'react';

import PropTypes from 'prop-types';

import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, key } from '@philips-emr/tws-utils';

function calculateEventBlockValues(event, startOfDay, endOfDay) {
  const { date, duration } = event;

  const hours = date.hour() - startOfDay;

  const dateMinutes = hours * 60 + date.minute();
  const totalMinutes = (endOfDay - startOfDay) * 60 + 60;

  const top = (dateMinutes * 100) / totalMinutes;
  const height = (100 * duration) / totalMinutes;

  return { top, height };
}

function EventBlock({ event, startOfDay, endOfDay }) {
  const { top, height } = calculateEventBlockValues(event, startOfDay, endOfDay);

  const style = {
    top: `calc(${top}% + 1px)`,
    height: `calc(${height}% - 1px)`,
  };

  const classes = {
    'c-calendar-event-block': true,
    'past-event': event.past,
  };

  return <div className={classNames(classes)} style={style} />;
}

EventBlock.propTypes = {
  event: PropTypes.object,
  startOfDay: PropTypes.number,
  endOfDay: PropTypes.number,
};

function HourText({ children }) {
  if (!Children.count(children)) {
    return null;
  }

  return <div className="c-calendar-hour__text">{msg(children)}</div>;
}

HourText.propTypes = {
  children: PropTypes.string,
};

function HourEvents({ events, endOfDay, startOfDay }) {
  if (!events || (events && !events.length)) {
    return null;
  }

  return events.map((event) => (
    <EventBlock
      key={key('c-calendar-event-block')}
      event={event}
      startOfDay={startOfDay}
      endOfDay={endOfDay}
    />
  ));
}

HourEvents.propTypes = {
  events: PropTypes.array,
  startOfDay: PropTypes.number,
  endOfDay: PropTypes.number,
};

function Hour({ text, events, endOfDay, startOfDay }) {
  return (
    <div className="c-calendar__hour">
      <HourText>{text}</HourText>
      <HourEvents events={events} endOfDay={endOfDay} startOfDay={startOfDay} />
    </div>
  );
}

Hour.propTypes = {
  text: PropTypes.string,
  events: PropTypes.array,
  startOfDay: PropTypes.number,
  endOfDay: PropTypes.number,
};

function WeeklyMobileHourColumn({ hours, endOfDay, startOfDay }) {
  return (
    <div className="c-calendar__column">
      {hours.map((hour) => (
        <Hour
          endOfDay={endOfDay}
          events={hour.events}
          key={key('c-calendar-hour')}
          startOfDay={startOfDay}
          text={hour.shortText}
        />
      ))}
    </div>
  );
}

WeeklyMobileHourColumn.propTypes = {
  hours: PropTypes.array,
  endOfDay: PropTypes.number,
  startOfDay: PropTypes.number,
};

export default WeeklyMobileHourColumn;
